import { Routes, Route } from 'react-router-dom';
import './App.css';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { globalAct } from './store/global';
import AddFarm from './pages/AddFarm';
import Index from './pages/Index';
import Dashboard from './pages/Dashboard';
import FarmPage from './pages/FarmPage';
import Page404 from './pages/Page404';
import LoginPage from './pages/LoginPage';
import FarmsMobile from './pages/FarmsMobile';
import Page403 from './pages/Page403';
import ImageComparison from './pages/ImageComparison';

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLogedIn } = useSelector((state) => state.global);

  useEffect(() => {
    if (isLogedIn && location.pathname !== '/login') {
      const observeApiKey = localStorage.getItem("observeearth_api_key") || localStorage.getItem("observearth_api_key");
      if (!observeApiKey) {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("Is_Superuser");
        localStorage.removeItem("observeearth_api_key");
        localStorage.removeItem("observearth_api_key");
        dispatch(globalAct.setIsLogedIn(false));
        navigate("/login");
      }
    }
  }, [isLogedIn, location.pathname, dispatch, navigate]);
  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<Dashboard />} />
        <Route path='login' element={<LoginPage />} />
        <Route path='index' element={<Index />} />
        <Route path='add-farm/:farmId' element={<AddFarm />} />
        <Route path='farms/:farmId' element={<FarmPage />} />
        <Route path="farms-comparison/:farmId" element={<ImageComparison />} />
        <Route path='farmsmobile/' element={<FarmsMobile />} />
        <Route path='/403' element={<Page403 />} />
        <Route path='/*' element={<Page404 />} />
      </Routes>
    </div>
  );
}

export default App;
